export default __webpack_public_path__ + "static/media/imac-mockup-01.15667264.png";